<section  style="background-image: url(../../../../assets/images/404-BG.jpg);height: 100vh;background-position: center;position: relative;">
    <img src="../../../../assets/images/404-cartoon.png" style="width: 60%;position: absolute;right: 5%;top: 50%;transform: translateY(-50%);">
    <div style="position: absolute; left: 5%; top: 50%; transform: translateY(-50%); ">
        <h1 style="font-size: 80px;color: black;">404</h1>
        <h3 class="h2" style="font-size:55px;">
            Look like you're lost
        </h3>
        <p>the page you are looking for not avaible!</p>
        <a href="/" style="color: #fff!important; text-decoration: none; padding: 10px 20px; background: #39ac31; margin: 20px 0; display: inline-block;">Go to Home</a>
    </div>

</section>

